import { NextActionStatusEnum } from '@data-access/bulk-operations-api';

export interface WsAssignUserActionCompleted {
  actionId: string;
  employeeId: string;
  actionStatus: NextActionStatusEnum;
  // set when 'actionStatus' is 'Failed'
  message?: string;
  failureType?: NextActionFailureTypeEnum;
}

export enum NextActionFailureTypeEnum {
  MustConfirmLinkToExistingUser = 'mustConfirmLinkToExistingUser',
}
